import { render, staticRenderFns } from "./OpenCartPackageAdd.vue?vue&type=template&id=a62da234&"
import script from "./OpenCartPackageAdd.vue?vue&type=script&lang=js&"
export * from "./OpenCartPackageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartPackageAdd.vue"
export default component.exports